import { createWMS } from './layers'
import { addGroupLayer, getWMS, map } from './tools'

export const addSubstituteBaseMaps = () => {
  ['gråtone'].forEach(id => {
    const wms = createWMS(`${id}WMS`).image['dynamicProjection'];
    // createWMS(`${id}WMS`).tile; // not loading when WMTS fills layer queue
    wms.setZIndex(0);
    wms.setVisible(false);
    map.addLayer(wms);
  });
};

let loadingTiles = 0;
export const substitute = (upd, retryTile) => {
  loadingTiles += upd;
  // console.log(loadingTiles);
  const current = document.getElementsByClassName('bg-highlight')[0]?.id;
  const currentlyGråtoner = current === 'graatoner';
  if (retryTile) setTimeout(() => retryTile.load(), 10000); // quick reply loop
  else getWMS('gråtoneWMS').setVisible(loadingTiles > 0 && currentlyGråtoner);
};

